import { useEffect } from "react"
import { useAuth } from "@clerk/clerk-react"
import { getSession } from "@/lib/api"
import { useStudioStore } from "@/store/studio"

export default function AuthSessionBootstrap() {
  const { getToken, isLoaded, isSignedIn } = useAuth()
  const setIdentity = useStudioStore((state) => state.setIdentity)
  const setBilling = useStudioStore((state) => state.setBilling)
  const setCapabilities = useStudioStore((state) => state.setCapabilities)
  const setYoutubeConnected = useStudioStore((state) => state.setYoutubeConnected)

  useEffect(() => {
    if (!isLoaded) return
    if (!isSignedIn) {
      ;(window as unknown as Record<string, unknown>).__atlas_token__ = null
      setIdentity(null)
      return
    }
    let cancelled = false
    const restore = async () => {
      let lastError: unknown
      for (let attempt = 0; attempt < 5 && !cancelled; attempt++) {
        try {
          if (attempt) await new Promise((resolve) => window.setTimeout(resolve, attempt * 500))
          const token = await getToken({ skipCache: attempt > 1 })
          if (!token) continue
          const session = await getSession(token)
          if (cancelled) return
          ;(window as unknown as Record<string, unknown>).__atlas_token__ = token
          setIdentity({ id: session.user.id, email: session.user.email, creditMicros: session.account.creditMicros })
          setBilling(session.billing)
          setCapabilities(session.capabilities)
          setYoutubeConnected(session.integrations.youtube.connected)
          return
        } catch (reason) { lastError = reason }
      }
      if (!cancelled) window.dispatchEvent(new CustomEvent("atlas:toast", { detail: { message: lastError instanceof Error ? lastError.message : "Your Atlas account is still reconnecting. Try refreshing once." } }))
    }
    void restore()
    return () => { cancelled = true }
  }, [getToken, isLoaded, isSignedIn, setBilling, setCapabilities, setIdentity, setYoutubeConnected])

  return null
}
